// extracted by mini-css-extract-plugin
export default {"title":"title_d0765936305ce07556ba","body":"body_d0b4f04accd93b2b18ea"};